export default {
  general: {
    name: "Juego de la Cerveza",
    yes: "si",
    no: "No",
    previous: "Antes",
    next: "Siguiente",
    ok: "Ok",
    confirmation: "Confirmación",
    week: "Semana",
    units: "{nbr} unidad | {nbr} unidad| {nbr} unidades",
    smallWeek: "S",
    timerMessage: "El tiempo se ha acabado. Por favor realice la acción a la brevedad posible!",
    wrongValue: "Valor incorrecto",
    gameFinished: "El juego ha terminado",
    gamePaused: "EL juego está en pausa",
    required: "requiere",
    stockFrom: "Stock de",
    assemblyStock: "Stock de montaje",
    testMode: "Este juego está en modo de prueba. No se puede utilizar con fines comerciales."
  },
  
  instructions: {
    chooseAvatar: "Elige tu avatar",
    title: "Instrucciones",
    step: "Paso",
    ready: "Estoy listo para jugar",
    wait: "Por favor espere que los otros jugadores estén listos",
    start: "Comenzar a jugar"
  },

  steps: {
    bufferSetup: " Parametros Buffer",
    clientOrder: "Ordenes de venta",
    clientShipment: "Envíos de clientes",
    supplierShimpentWaiting: "Esperando entregas",
    board: "Tablero de control",
    supplierShipments: "Entregas de los proveedores",
    supplierOrders: "Ordenes de proveedores",
    productionBatch: "Lanzar la producción",
    productionShipments: "Entregas de producción",
    startNewWeek: "Comience una nueva semana",
    youCanStartNewWeek: "Puedes comienzar una nueva semana",
    inProgressProduction: "Trabajo en curso",
    flowEquationCalc: "Ecuación de flujo neto",
    clientOrderTitleMessage: "Has recibido una órden de venta"
  },

  clientsShimpents: {
    chooseQuantity: "Por favor ingrese los pedidos entregados",
    notMax: "Por favor, entregue el máximo de productos disponibles",
    remains: "Ordenes de venta (pasadas y actuales) : ",
    ok : "Aceptar los envíos",
    shipmentsResume: "Has entregado {nbr} unidad a tus clientes | Has entregado {nbr} unidades a tus clientes",
    remainResume: "Tienes un retraso de {nbr} unidad | Tienes un retraso de {nbr} unidades "
  },

  board: {
    cantOrder: "No puede pasar órdenes en este momento",
    cantProduce: "No puede lanzar una orden de producción por el momento"
  },

  suppliersShipments: {
    shipments: "Entregas desde",
    production: "Has producido {nbr} unidad | Has producido {nbr} unidades",
    getShipments: "Recepción",
    waitShipment: "Por favor espere sus entregas",
    stockChange: "Tu stock es de {nbr} unidad | Tu stock es de {nbr} unidades",
    stockChangeTitle: "Actualización de tu inventario"
  },

  suppliersOrders: {
    maxOrder: "Cantidad máxima ",
    ordersTo: "Ordenes a ",
    remainsAlert: "Atencion: casi envías todos los pedidos de tus clientes!",
    production: "Cantidad a lanzar",
    orders: "Ordenes",
    ok : "Aceptar pedidos a los proveedores",
    okProduction: "Aceptar el lanzamiento de la producción"
  },

  stats: {
    suppliersRemains: "pedidos pendientes de proveedores",
    buffers: "Buffers",
    resume: "En resumen",
    orders: "Ordenes",
    stock: "Inventario",
    remains: "Ruptura de stock",
    cost: "Costos",
    stockDelay: "Inventario y ruptura de stock",
    companies: "empresa",
    red: "Zona roja",
    yellow: "Zona amarilla",
    green: "Zona verde",
    flowEquation: "Flujo neto"
  },

  dd: {
    cmj: "Consumo promedio diario ",
    leadTime: "Plazo de entrega",
    variabilityFactor: "Factor de variabilidad",
    delayFactor: "Factor de plazo de entrega",
    availableStock: "Inventario disponible",
    clientsRemains: "Demanda calificada",
    suppliersRemains: "Pedidos de proveedores",
    AverageStockLevelTarget: "meta de inventario promedio",
    falseOrder: "Usted no ha pedido la cantidad correcta",
    applyAutoCmj: "Aplicar automaticamente el consumo promedio diario calculado",
    calculatedCMJ: "Consumo promedio diario calculado" 
  },

  debrief: {
    resume: {
      name: "Nombre",
      level: "Nivel Ranking",
      resume: "Resumen",
      averageOrderQuantity: "Pedidos al proveedor en promedio",
      averageRequestQuantity: "Demanda promedio del cliente",
      range: "Rango de demanda",
      otd: "Pedido a la hora exacta",
      delaysDepth: "Retrazo en semanas",
      averageStock: "Inventario disponible en promedio",
      stockCost: "Costo de inventario",
      delayCost: "Costo de ruptura de stock",
      cost: "Costo total",
    }
  },

  user : {
    noParties : 'Ningun juego corresponde a este código y este cuenta',
    falseTrainningKey : '<código del animador incorrecto',
    welcome : "Bienvenido al juego ",
    noMorePlace : "El numero de participantes está completo",
    notOpen: "El juego está listo",
    logoutConfirmation: "Está seguro que desea terminar el juego? ",
    sessionExpired: "Su sesión ha expirado, por favor inicie sesión de nuevo"
  },

  store : {
    error : "Error : "
  }
}